'use client';
import { FunctionComponent } from 'react';
import Company from '@business/general/Company';
import { useAppActionDispatch, useAppStateSelector } from '@redux/hooks';
import ALink from '@xFrame4/components/next/ALink';
import { getMenuItemsForLanguage } from 'frontend_business/menus/Menus';
import { useLanguageFromRoute } from '@components/Hooks';

export interface DesktopMenuProps
{

}

/**
 * Component: menu for desktop
 */
const DesktopMenu: FunctionComponent<DesktopMenuProps> = (props) =>
{
    // get the language from the params
    const languageFromRoute = useLanguageFromRoute();
    const language = useAppStateSelector(state => state.layout.language?.code);
    const menuItems = getMenuItemsForLanguage(language ?? languageFromRoute);

    /** Render */
    return (
        <div className="menu desktop-menu bg-secondary py-2">
            <div className="container d-flex justify-content-end">
                {menuItems.map((item) => (
                    <div key={item.orderNo}>
                        <ALink 
                            href={item.url}
                            className="desktop-menu-item text-white text-decoration-none ms-6 font-size-r105 font-weight-500 text-uppercase"
                        >
                            {item.name}
                        </ALink>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DesktopMenu;